// extracted by mini-css-extract-plugin
export default {"back":"BackComponent_back__CucD-","backContentButton":"BackComponent_backContentButton__VJSAA"};